<script>
import InputRut from "./InputRut.vue";
import InputRegion from "./InputRegion.vue";
import Swal from "sweetalert2";

import axios from "axios";
import AppChips from "./AppChips.vue";
import AppSearchSelector from "./AppSearchSelector.vue";
import AppSearchSelectorObj from "./AppSearchSelectorObj.vue";

export default {
  components: {
    InputRut,
    InputRegion,
    AppChips,
    AppSearchSelector,
    AppSearchSelectorObj,
  },
  name: "FormUsuario",
  emits: ["input"],
  props: {
    value: Object,
    user: Object,
    roles: Array,
    password: Boolean,

    selectedItem: {},
  },
  data() {
    return {
      clientList: [],
      //selectedClients: [],
    };
  },
  computed: {
    availableClients() {
      return this.clientList.filter(
        (client) =>
          !this.value.selectedClients.some(
            (selected) => selected.value == client.value
          )
      );
    },
  },
  methods: {
    async fetchClients() {
      try {
        const { data } = await axios.get('/api/list?get=["clientes"]');

        if (data?.data?.clientes) this.clientList = data.data.clientes;
      } catch (err) {
        console.error(err);
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Hubo un error al obtener el listado de clientes.",
        });
      }
    },
    dropClient(id) {
      this.value.selectedClients = this.value.selectedClients.filter(
        (selected) => selected.key != id
      );
    },
    //
  },
  async mounted() {
    await this.fetchClients();
  },
};
</script>

<template>
  <div class="flex flex-col gap-8">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-8">
      <b-form-group
        class="text-left form-label"
        label="Usuario"
        label-for="username-input"
      >
        <input
          id="username-input"
          v-model="value.username"
          min="3"
          max="190"
          required
        />

        <div class="text-left">
          <span id="username"></span>
        </div>
      </b-form-group>

      <b-form-group class="text-left" label="Nombre" label-for="name-input">
        <input
          id="name-input"
          v-model="value.name"
          min="3"
          max="190"
          required
        />

        <div class="text-left">
          <span id="name"></span>
        </div>
      </b-form-group>

      <b-form-group class="text-left" label="Teléfono" label-for="phone-input">
        <input id="phone-input" min="9" max="11" v-model="value.phone" />
        <div class="text-left">
          <span id="phone"></span>
        </div>
      </b-form-group>

      <b-form-group
        v-if="roles"
        class="text-left"
        label="Rol"
        label-for="rol-select"
      >
        <select id="rol-select" v-model="value.rol" required>
          <option value="">Seleccione un Rol</option>
          <option v-for="(rol, index) in roles" :key="index" :value="rol.value">
            {{ rol.text }}
          </option>
        </select>
      </b-form-group>
    </div>

    <div
      class="sm:col-span-2 text-left flex flex-col gap-8"
      v-if="value.rol === 'outsourcing'"
    >
      <div class="flex flex-col gap-2">
        <label>Clientes</label>

        <!--
        <app-search-selector-obj
          v-model="selectedItem"
          :options="availableClients"
          key-value="key"
          label-value="value"
          :key="availableClients.length + 'selector'"
        />
        -->
        <select
          @change="
            (e) => {
              value.selectedClients.push(JSON.parse(e.target.value));
              //value.selectedClients = [...selectedClients];
            }
          "
        >
          <option value="" selected>Seleccione un cliente</option>
          <option
            v-for="client in availableClients"
            :key="client.value"
            :value="JSON.stringify(client)"
          >
            {{ client.value }}
          </option>
        </select>
      </div>
      <app-chips
        :items="value.selectedClients"
        key-value="key"
        label-value="value"
        @drop-item="
          (id) => {
            dropClient(id);
            //value.selectedClients = [...valueselectedClients];
          }
        "
      />
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-8">
      <b-form-group class="text-left" label="Correo" label-for="email-input">
        <input type="email" id="email-input" v-model="value.email" required />

        <div class="text-left">
          <span id="email"></span>
        </div>
      </b-form-group>

      <b-form-group
        class="text-left"
        label="Confirmar Correo"
        label-for="email_confirmation-input"
      >
        <input
          type="email"
          id="email_confirmation-input"
          v-model="value.email_confirmation"
          required
        />

        <div class="text-left">
          <span id="email_confirmation"></span>
        </div>
      </b-form-group>
    </div>

    <div class="grid grid-grid-cols-1 sm:grid-cols-2 gap-8">
      <b-form-group
        v-if="password"
        class="text-left"
        label="Contraseña"
        label-for="password-input"
      >
        <input
          type="password"
          id="password-input"
          v-model="value.password"
          required
        />

        <div class="text-left">
          <span id="password"></span>
        </div>
      </b-form-group>

      <b-form-group
        v-if="password"
        class="text-left"
        label="Confirmar Contraseña"
        label-for="password-confirmation-input"
      >
        <input
          type="password"
          id="password-confirmation-input"
          v-model="value.password_confirmation"
          required
        />

        <div class="text-left">
          <span id="password_confirmation"></span>
        </div>
      </b-form-group>
    </div>

    <b-form-group>
      <slot name="cambiarPassword"></slot>
    </b-form-group>

    <div class="flex flex-row justify-end">
      <button class="btn-principal ml-auto" type="submit">Guardar</button>
      <slot></slot>
    </div>
  </div>
</template>

<style></style>
